export default __webpack_public_path__ + "static/media/kompacto.0cc4f76c.glb";